import { XAxis, YAxis, Tooltip, ResponsiveContainer, BarChart, Bar, Cell, CartesianGrid, Legend, PieChart, Pie } from "recharts";
import { formatINR } from "@/lib/format";
import { COLORS, CHART_MARGIN, AXIS_LINE, TOOLTIP_STYLE, BAR_CURSOR, LEGEND_STYLE, inrTick, inrValue } from "./chartTheme";

export function CategoryCharts({ catTrend, cats }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 mt-6">
      <div className="lg:col-span-3 border border-[#D8D4C7] bg-white p-6">
        <div className="mb-4">
          <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#6C7565]">Top categories · month over month</div>
          <h4 className="font-serif text-2xl tracking-tight">Category trend</h4>
        </div>
        <div className="h-72" data-testid="chart-category-trend">
          {!catTrend || catTrend.categories.length === 0 ? (
            <div className="h-full flex items-center justify-center text-[#6C7565] text-sm">No expense data yet.</div>
          ) : (
            <ResponsiveContainer>
              <BarChart data={catTrend.months} margin={CHART_MARGIN}>
                <CartesianGrid stroke="#EAE7DD" vertical={false} />
                <XAxis dataKey="month" stroke="#6C7565" fontSize={10} tickLine={false} axisLine={AXIS_LINE} />
                <YAxis stroke="#6C7565" fontSize={10} tickLine={false} axisLine={AXIS_LINE} tickFormatter={inrTick} />
                <Tooltip contentStyle={TOOLTIP_STYLE} formatter={inrValue} cursor={BAR_CURSOR} />
                <Legend wrapperStyle={LEGEND_STYLE} />
                {catTrend.categories.map((c, i) => (
                  <Bar key={c} dataKey={c} stackId="cat" fill={COLORS[i % COLORS.length]} maxBarSize={28} />
                ))}
              </BarChart>
            </ResponsiveContainer>
          )}
        </div>
      </div>

      <div className="lg:col-span-2 border border-[#D8D4C7] bg-white p-6">
        <div className="mb-4">
          <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#6C7565]">Selected range share</div>
          <h4 className="font-serif text-2xl tracking-tight">Category share</h4>
        </div>
        <div className="h-72" data-testid="chart-category-share">
          {cats.length === 0 ? (
            <div className="h-full flex items-center justify-center text-[#6C7565] text-sm">No data.</div>
          ) : (
            <ResponsiveContainer>
              <PieChart>
                <Tooltip contentStyle={TOOLTIP_STYLE} formatter={inrValue} />
                <Pie data={cats.slice(0, 7)} dataKey="current" nameKey="category" innerRadius={55} outerRadius={100} paddingAngle={2}>
                  {cats.slice(0, 7).map((c, i) => <Cell key={c.category} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          )}
        </div>
        <ul className="mt-2 space-y-1.5">
          {cats.slice(0, 7).map((c, i) => (
            <li key={c.category} className="flex items-center justify-between text-xs">
              <span className="flex items-center gap-2">
                <span className="w-2.5 h-2.5" style={{ background: COLORS[i % COLORS.length] }} />
                <span className="font-mono uppercase tracking-wider text-[#6C7565]">{c.category}</span>
              </span>
              <span className="num">{formatINR(c.current, { compact: true })}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
